import { create } from 'zustand';
import axios from 'axios';

const useBrandingStore = create((set) => ({
    branding: {
        logo_url: null,
        company_name: 'MAKER AI POS'
    },
    loading: false,

    fetchBranding: async () => {
        set({ loading: true });
        try {
            const token = localStorage.getItem('token');
            const [brandRes, compRes] = await Promise.all([
                axios.get('/api/branding'),
                axios.get('/api/company', { headers: { Authorization: `Bearer ${token}` } }).catch(() => ({ data: { name: 'MAKER AI POS' } }))
            ]);

            const data = {
                logo_url: brandRes.data?.logo_url,
                company_name: compRes.data?.name || 'MAKER AI POS'
            };
            set({ branding: data, loading: false });
            return data;
        } catch (error) {
            console.error('Failed to fetch branding:', error);
            set({ loading: false });
            return null;
        }
    },

    updateBranding: (data) => {
        set((state) => ({
            branding: { ...state.branding, ...data }
        }));
    }
}));

export default useBrandingStore;
